<template>
  <div class="navbar">
    <div class="container">
      <div :class="classObject()">
        <div class="navbar__back" v-if="backRoutes">
          <back />
        </div>
        <div class="navbar__nav">
          <link-theme
            :label="options.navbar.backToSite"
            :back="true"
            :name="options.navbar.backToSite"
            @click="handleClickBack"
          />
          <link-theme
            :label="options.navbar.langDefault"
            :name="options.navbar.langDefault"
            :uppercase="true"
            @click="handleClickLangs"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import back from './back.vue';
import linkTheme from './linkTheme.vue';

export default {
  name: 'topBar',
  components: {
    back,
    linkTheme,
  },
  props: {},
  data() {
    return {};
  },
  created() {},
  computed: {
    options() {
      return this.$store.state.siteData;
    },
    backRoutes() {
      return this.$route.meta.back;
    },
  },
  methods: {
    classObject() {
      return {
        navbar__wrapper: true,
        'has-back': this.backRoutes,
      };
    },
    handleClickBack() {
      this.$emit('clickBack');
    },
    handleClickLangs() {
      this.$emit('clickLangs');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  background-color: transparent;
  pointer-events: none;
  transition: background-color .25s, box-shadow .3s;

  @include up-laptop {
    z-index: 2;
  }

  &.has-bg {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.095389);
  }

  &__wrapper {
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;

    @include up-tablet {
      padding: 20px 0;
      justify-content: flex-start;
    }

    @include up-desktop {
      padding: 30px 0;
    }

    &.has-back {
      justify-content: space-between;
    }
  }

  &__back,
  &__nav {
    pointer-events: all;
  }

  &__nav {
    margin: 11px 0;
    display: flex;
    align-items: center;

    @include up-tablet {
      margin: 10px 0;
      justify-content: flex-start;
    }

    @include up-laptop {
      position: absolute;
      top: 0;
      z-index: 20;
      padding: 30px 0;

      .has-back & {
        right: 30px;
      }
    }

    & > * + * {
      margin: 0 0 0 17px;
    }
  }
}
</style>
